import preval from 'preval.macro';

export const versionNumber = preval`
const Package = require('../../package.json');
module.exports = 'v' + Package.version + '.' + new Date().toISOString().match(/[0-9]/g).slice(0,14).join('');
`;
